export enum Period {
  Day = 'Day',
  Month = 'Month',
  QuarterYear = 'QuarterYear',
  HalfYear = 'HalfYear',
  Year = 'Year',
}
